import { TenantAssets } from "../../../assets/assets";
import logo from "./logo/logo.webp";

export const Assets: TenantAssets = {
  logo,
};
